import type5asec from '@/images/icons/type-5asec.svg';
import typeAcompanhamentoObraSeazone from '@/images/icons/type-acompanhamento-obra-seazone.svg';
import typeAcompanhamentoObraMM from '@/images/icons/type-acompanhamentoObraMM.svg';
import typeAditivo from '@/images/icons/type-aditivo.svg';
import typeIntermediariaBHomy from '@/images/icons/type-aditivo.svg';
import typeAtestado from '@/images/icons/type-atestado.svg';
import typeAuditoriaLoja from '@/images/icons/type-auditoriaLoja.svg';
import typeAvaliacao from '@/images/icons/type-avaliacao.svg';
import typeAvaliacaoHousi from '@/images/icons/type-avaliacaoHousi.svg';
import typeAvaliacaoImobiliaria from '@/images/icons/type-avaliacaoImobiliaria.svg';
import typeAvaliacaoZap from '@/images/icons/type-avaliacaoZap.svg';
import typeCacaVazamento from '@/images/icons/type-caca-vazamento.svg';
import typeCautelar from '@/images/icons/type-cautelar.svg';
import typeCautelarAterpa from '@/images/icons/type-cautelarAterpa.svg';
import typeCautelarCCInfra from '@/images/icons/type-cautelarCCInfra.svg';
import typeCautelarQueirozGalvao from '@/images/icons/type-cautelarQueirozGalvao.svg';
import typeChaves from '@/images/icons/type-chaves.svg';
import typeChecklistSamsung from '@/images/icons/type-checklistSamsung.svg';
import typeConferencia from '@/images/icons/type-conferencia.svg';
import typeConferenciaFinalDeObra from '@/images/icons/type-conferenciaFinalDeObra.svg';
import typeCurtaTemporada from '@/images/icons/type-curta-temporada.svg';
import typeEntradaCurtaTemporada from '@/images/icons/type-entrada-curta-temporada.svg';
import typeEntrada from '@/images/icons/type-entrada.svg';
import typeEntradaBHomy from '@/images/icons/type-entradaBHomy.svg';
import typeEntradaLight from '@/images/icons/type-entradaLight.svg';
import typeEntrega from '@/images/icons/type-entrega.svg';
import typeEntregaHacasa from '@/images/icons/type-entrega.svg';
import typeFichaCerta from '@/images/icons/type-fichacerta.svg';
import typeFinalDeObra from '@/images/icons/type-finalDeObra.svg';
import typeFotos from '@/images/icons/type-fotos.svg';
import typeInspecaoPredial from '@/images/icons/type-inspecaoPredial.svg';
import typeInventario from '@/images/icons/type-inventario.svg';
import typeMedicaoObraTrinus from '@/images/icons/type-medicao-obra-trinus.svg';
import typeMedicao from '@/images/icons/type-medicao.svg';
import typeNone from '@/images/icons/type-none.svg';
import typePiloto from '@/images/icons/type-piloto.svg';
import typePredial from '@/images/icons/type-predial.svg';
import typePredialO2 from '@/images/icons/type-predialO2.svg';
import typePreVistoriaBHomy from '@/images/icons/type-preVistoriaBHomy.svg';
import typeSaidaCurtaTemporada from '@/images/icons/type-saida-curta-temporada.svg';
import typeSaida from '@/images/icons/type-saida.svg';
import typeSeguroLever from '@/images/icons/type-seguro-lever.svg';
import typeSignature from '@/images/icons/type-signature.svg';
import typeTombamento from '@/images/icons/type-tombamento.svg';
import typeTourVirtual from '@/images/icons/type-tour-virtual.svg';
import typeTransferencia from '@/images/icons/type-transferencia.svg';
import typeVisitaDigital from '@/images/icons/type-visita-digital.svg';

const icons = {
  '5asec': type5asec,
  acompanhamentoObraMM: typeAcompanhamentoObraMM,
  aditivo: typeAditivo,
  auditoriaLoja: typeAuditoriaLoja,
  auditoriaCbre: typeAuditoriaLoja,
  auditoriaVaapty: typeAuditoriaLoja,
  fast4You: typeAuditoriaLoja,
  smartEsquadrias: typeAuditoriaLoja,
  levantamentoVivara: typeAuditoriaLoja,
  auditoriaAbcConstrucao: typeAuditoriaLoja,
  atestado: typeAtestado,
  avaliacao: typeAvaliacao,
  avaliacaoHousi: typeAvaliacaoHousi,
  avaliacaoImobiliaria: typeAvaliacaoImobiliaria,
  avaliacaoZap: typeAvaliacaoZap,
  cacaVazamento: typeCacaVazamento,
  cautelar: typeCautelar,
  cautelarAterpa: typeCautelarAterpa,
  cautelarCCInfra: typeCautelarCCInfra,
  cautelarQueirozGalvao: typeCautelarQueirozGalvao,
  chaves: typeChaves,
  checklistSamsung: typeChecklistSamsung,
  conferencia: typeConferencia,
  conferenciaFinalDeObra: typeConferenciaFinalDeObra,
  conferenciaEntrega: typeEntrega,
  constatacao: typeEntrada,
  entrada: typeEntrada,
  entradaBHomy: typeEntradaBHomy,
  entradaLight: typeEntradaLight,
  entrega: typeEntrega,
  entregaHacasa: typeEntregaHacasa,
  finalDeObra: typeFinalDeObra,
  finalDeObraBoticario: typeFinalDeObra,
  inspecaoPredial: typeInspecaoPredial,
  inventario: typeInventario,
  inventarioEquipamentosVtal: typeInventario,
  inventarioElementosRede: typeInventario,
  medicao: typeMedicao,
  piloto: typePiloto,
  predial: typePredial,
  predialO2: typePredialO2,
  preVistoriaBHomy: typePreVistoriaBHomy,
  saida: typeSaida,
  signature: typeSignature,
  tombamento: typeTombamento,
  transferencia: typeTransferencia,
  visitaDigital: typeVisitaDigital,
  fotos: typeFotos,
  fotosDeCaptacao: typeFotos,
  seguroLever: typeSeguroLever,
  tourVirtual: typeTourVirtual,
  intermediariaBHomy: typeIntermediariaBHomy,
  entradaCurtaTemporada: typeEntradaCurtaTemporada,
  saidaCurtaTemporada: typeSaidaCurtaTemporada,
  fichaCerta: typeFichaCerta,
  curtaTemporada: typeCurtaTemporada,
  acompanhamentoObraSeazone: typeAcompanhamentoObraSeazone,
  medicaoObraTrinus: typeMedicaoObraTrinus,
};

function orderIcon(orderType) {
  if (!orderType) return typeNone;
  if (icons[orderType]) return icons[orderType];

  const normalizedKey = String(orderType)
    .replace(/^VISTORIA_/i, '')
    .toLowerCase()
    .replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());

  return icons[normalizedKey] || icons[String(orderType).toLowerCase()] || typeNone;
}

export default orderIcon;
